module.exports = __webpack_public_path__ + "media/ts.46825ee2.wav";